<google-map #googleMap
  [height]="height"
  [width]="width"
  [zoom]="zoom"
  [center]="center"
  [options]="options"
  (idle)="idle()"
/>
